import { Link } from 'react-router-dom';
import { useVideoTransition } from '../../hooks/useVideoTransition';

const StillButton = ({ 
  children, 
  className = '', 
  onClick,
  to,
  as,
  'aria-label': ariaLabel,
  disabled = false,
  ...props 
}) => {
  const { handleNavigate } = useVideoTransition();
  const baseStyles = "inline-block px-8 py-1 border border-still-blue outline-glow-blue text-lg uppercase text-still-pink bg-black bg-opacity-30 rounded-full hover:bg-gl transition-all transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50";
  
  const handleClick = (e) => {
    // If disabled, don't do anything
    if (disabled) {
      e.preventDefault();
      return;
    }
    
    // For links, prevent default and use the router
    if (to) {
      e.preventDefault();
      //console.log('[StillButton] Navigating to:', to);
      //console.log('[StillButton] Current location:', window.location.pathname);
      //console.log('[StillButton] Using handleNavigate from useVideoTransition');
      handleNavigate(to);
      //console.log('[StillButton] handleNavigate called');
    }
    
    // Call the onClick handler if provided
    if (onClick) {
      //console.log('[StillButton] Calling onClick handler');
      onClick(e);
      //console.log('[StillButton] onClick handler called');
    }
  };

  // Determine the final className, including disabled state
  const finalClassName = `${baseStyles} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`;

  // If 'as' is explicitly set to 'button' or there's no 'to' prop, render a button
  if (as === 'button' || !to) {
    return (
      <button
        className={finalClassName}
        aria-label={ariaLabel}
        onClick={handleClick}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    );
  }

  // Otherwise, render a Link
  return (
    <Link
      to={to}
      className={finalClassName}
      aria-label={ariaLabel}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  );
};

export default StillButton;